import { Injectable } from '@angular/core';
import { HttpService } from './shared/http/base.http';
import { ICustomerInquiryModel } from './property-detail/property.modal';
@Injectable()
export class ApiService extends HttpService {
   getAllPropertyForSale() {
      return this.get<any>('/buy/getAllProperty');
   }
   getAllPropertyForRent() {
      return this.get<any>('/rent/getAllProperty');
   }
   getPropertyDetail(id: string) {
    return this.get<any>('/buy/getPropertyDetai?propertyId=' + id);
   }
   savePropertyInquiry(data: ICustomerInquiryModel){
      return this.post('/property/createCustomerInquiry', data, { 'content-type': 'application/json; charset=utf-8' });
   }
   getCategoryList(){
      return this.get<any>('/masterdata/getCategories');
   }
   getBlogList() {
      return this.get<any>('/public/getBlogList');
  }

  getBlogDetails(id: string) {
      return this.get<any>('/public/getBlogDetails?blogId=' + id);
  }

  getCampaignDetails(id: string) {
   return this.get<any>('/campaign/getCampaignDetails?campaignId=' + id);
}

}
